// import GlobalMixin from '@/app/shared/mixins/global';
import { behaviorGroup, getTocLayerId, isArray } from '@config/utils';
import { get as getProjection } from 'ol/proj';

export default {
    mixins: [
        // GlobalMixin,
    ],
    props: {
        map: {
            type: Object,
            default: null,
        },
        node: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            BEHAVIOR_GROUP: behaviorGroup,
        }
    },
    mounted() {

    },
    computed: {
        hasLegendLayer() {
            let node = this.node;
            return node ? !!(node.legend_automatic || (this.node.legend_layer && this.node.legend_layer.length)) : false;
        },
        enableLegendLayer() {
            return this.hasLegendLayer
        },
        legendUrlLayer() {
            let node = this.node;
            if(node.legend_automatic){
                let _map = this.map;
                let layer = this.getOLLayer(node);
                if(!layer){
                    layer = this.setLayerOnMap(node);
                }
                if(layer){
                    let legend_url = layer.get('legend_url');
                    if(legend_url) {
                        return legend_url;
                    }else{
                        let owsSource = layer.getSource()
                        let resolution = _map.getOLMapView().getResolution();
                        return typeof owsSource.getLegendUrl === 'function' ? owsSource.getLegendUrl(resolution) : null;
                    }
                }
            }else if(node.legend_layer){
                return node.legend_layer;
            }
            return null;
        },
    },
    methods: {
        isNodeLayer(node){
            return node.resources != undefined
                    || node.layers != undefined;
        },
        isNodeGroup(node) {
            return node.children && node.behavior == this.BEHAVIOR_GROUP;
        },
        layerNode(node){
            return node.resources && node.resources.length ? node.resources[0] : node;
        },
        applyStateOnMap(node){
            if(this.isNodeLayer(node)){
                this.setLayerOnMap(node);
            }
        },
        setLayerOnMap: function(baseNode) {
            let _map = this.map;
            if(_map){
                let node = this.layerNode(baseNode);
                let layer = this.getOLLayer(node);
                if(!layer) {
                    if(node.tiled === undefined){
                        node.tiled = true;
                    }

                    let mapProjection = _map?.getProjection();
                    let mapProjectionCode = mapProjection?.getCode();
                    let srs = node.srs ? (node.srs.code ? node.srs.code : node.srs)
                                : node.crs ? node.crs : (node.allowedSRS && Object.keys(node.allowedSRS).includes(mapProjectionCode) ? mapProjectionCode : 'EPSG:4326');
                    let featureInfo = node.featureInfo || node.feature_info || baseNode.featureInfo || baseNode.feature_info || {};
                    let type = node.service ? (node.service && node.service.service ? node.service.service.code.toLowerCase() : node.service.code.toLowerCase()) : (node.type ? node.type.toLowerCase() : null);
                    let url = node.url || (node.service ? node.service.url : null);
                    let conf = {
                        id: baseNode.id,
                        type: type,
                        url: url,
                        name: baseNode.name,
                        visible: baseNode.state.checked,
                        zIndex: baseNode.zindex || this.calcZIndexLayer(baseNode),
                        // serverType: node.server_type ? node.server_type.code : null,
                        transition: node.transition || 0,
                        attributions: node.attribution || node.attributions || node.credits || baseNode.attribution || baseNode.attributions,
                        srs: srs,
                        crs: srs,
                        projection: getProjection(srs) || mapProjection,
                        style: node.style,
                        format: node.format ? (node.format.code ? node.format.code : node.format) : 'image/png',
                        wrapX: node.wrapX || false,
                        bbox: node.bbox || null,
                        featureInfo: featureInfo,
                        queryable: !!(node.queryable || featureInfo.queryable),
                        tools: baseNode.tools || null,
                        legend_url: node.legend && node.legend.url ? node.legend.url : null,
                    };

                    if(conf.type){
                        switch(type.toLowerCase()) {
                            case 'wms':
                                let wmsConf = {
                                    params: {
                                        'SERVICE': conf.type,
                                        'VERSION': node.service && node.service.version ? node.service.version.code : (node.version ? node.version : '1.1.1'),
                                        'FORMAT': conf.format,
                                        'SRS': conf.srs,
                                        'CRS': conf.crs,
                                        'LAYERS': node.layers,
                                        'TRANSPARENT': node.transparent || true,
                                        'CQL_FILTER': null,
                                        // 'EXCEPTIONS': 'application/vnd.ogc.se_inimage',
                                        // 'JWT': node.ogc_internal && node.private ? localStorage.getItem('credentials') : ''
                                        'JWT': node.private ? localStorage.getItem('credentials') : ''
                                    },
                                };
                                wmsConf = {...conf, ...wmsConf};
                                layer = node.tiled ? _map.createTileLayer(wmsConf) : _map.createImageLayer(wmsConf);
                                break;
                            case 'wmts':
                                // var parser = new WMTSCapabilities();
                                // fetch('https://cartografia.dgterritorio.gov.pt/ortos2018/service?service=wmts&request=getcapabilities')
                                //   .then(function (response) {
                                //     return response.text();
                                //   })
                                //   .then(function (text) {
                                //     var result = parser.read(text);
                                //     var options = optionsFromCapabilities(result, {
                                //         layer: 'Ortos2018-RGB',
                                //         matrixSet: 'EPSG:3763',
                                //     });
                                //     console.log('options:', options);
                                //   });
                                const localSupportedCRSPropName = 'supported_crs';
                                const localMatrixIdsPropName = 'tilematrixs';
                                const localScaleDenominatorPropName = 'scale_denominator';
                                const localIdentifierPropName = 'identifier';
                                const localTopLeftCornerPropName = 'top_left_corner';
                                const localMatrixWidthPropName = 'matrix_width';
                                const localMatrixHeightPropName = 'matrix_height';
                                const localTileWidthPropName = 'tile_width';
                                const localTileHeightPropName = 'tile_height';

                                const supportedCRSPropName = 'ows:SupportedCRS';
                                const matrixIdsPropName = 'TileMatrix';
                                const scaleDenominatorPropName = 'ScaleDenominator';
                                const identifierPropName = 'ows:Identifier';
                                const topLeftCornerPropName = 'TopLeftCorner';
                                const matrixWidthPropName = 'MatrixWidth';
                                const matrixHeightPropName = 'MatrixHeight';
                                const tileWidthPropName = 'TileWidth';
                                const tileHeightPropName = 'TileHeight';

                                if(node.allowedSRS && node.allowedSRS[mapProjectionCode]){
                                    let tileMatrixSets = node.tileMatrixSet || node.tilematrixsets;
                                    let tileMatrixSet = tileMatrixSets.find(m => {
                                        return this.getEPSGCode(m[supportedCRSPropName] || m[localSupportedCRSPropName]) == mapProjectionCode
                                    });
                                    if(tileMatrixSet){
                                        tileMatrixSet = tileMatrixSet.length ? tileMatrixSet[0] : tileMatrixSet;
                                        let tileMatrixs = tileMatrixSet[matrixIdsPropName] || tileMatrixSet[localMatrixIdsPropName];
                                        if(tileMatrixs){
                                            tileMatrixs.sort(function (a, b) {
                                                return scaleDenominatorPropName in a ? parseFloat(b[scaleDenominatorPropName]) - parseFloat(a[scaleDenominatorPropName]) : parseFloat(b[localScaleDenominatorPropName]) - parseFloat(a[localScaleDenominatorPropName]);
                                            });
                                        }
                                        const code = tileMatrixSet[supportedCRSPropName] || tileMatrixSet[localSupportedCRSPropName];
                                        const projection = _map.getProjectionFromCode(code);
                                        const metersPerUnit = projection.getMetersPerUnit();
                                        let matrixId = tileMatrixSet[identifierPropName] || tileMatrixSet[localIdentifierPropName];

                                        let resolutions = [];
                                        let matrixIds = [];
                                        let origins = [];
                                        let sizes = [];
                                        let tileSizes = [];
                                        tileMatrixs.forEach(matrix => {
                                            matrixIds.push(identifierPropName in matrix ?
                                                (isNaN(matrix[identifierPropName]) ? matrix[identifierPropName] :
                                                    (matrix[identifierPropName])) :
                                                (isNaN(matrix[localIdentifierPropName]) ? matrix[localIdentifierPropName] :
                                                    (matrix[localIdentifierPropName])));
                                            resolutions.push((parseFloat(scaleDenominatorPropName in matrix ? matrix[scaleDenominatorPropName] : matrix[localScaleDenominatorPropName]) * 0.00028) / metersPerUnit);
                                            origins.push( (topLeftCornerPropName in matrix ? matrix[topLeftCornerPropName] : matrix[localTopLeftCornerPropName]).split(' ').map(v => Number(v)) );
                                            if(localMatrixWidthPropName in matrix && localMatrixHeightPropName in matrix){
                                                sizes.push([matrix[localMatrixWidthPropName], matrix[localMatrixHeightPropName]]);
                                            }else if(matrixWidthPropName in matrix && matrixHeightPropName in matrix){
                                                sizes.push([matrix[matrixWidthPropName], matrix[matrixHeightPropName]]);
                                            }
                                            if(localTileWidthPropName in matrix && localTileHeightPropName in matrix){
                                                tileSizes.push([matrix[localTileWidthPropName], matrix[localTileHeightPropName]]);
                                            }else if(tileWidthPropName in matrix && tileHeightPropName in matrix){
                                                tileSizes.push([matrix[tileWidthPropName], matrix[tileHeightPropName]]);
                                            }
                                        });

                                        // let wmtsConf = {
                                        //     layer: node.layers,
                                        //     requestEncoding: node.requestEncoding,
                                        //     matrixSet: matrixId,
                                        //     matrixIds: matrixIds.map(m => identifierPropName in m ? (isNaN(m[identifierPropName]) ? m[identifierPropName] : Number(m[identifierPropName])) : (isNaN(m[localIdentifierPropName]) ? m[localIdentifierPropName] : Number(m[localIdentifierPropName]))),
                                        //     resolutions: matrixIds ? matrixIds.map(m => (Number(scaleDenominatorPropName in m ? m[scaleDenominatorPropName] : m[localScaleDenominatorPropName]) * 0.28e-3) / metersPerUnit) : null,
                                        //     origins: matrixIds ? matrixIds.map(m => (topLeftCornerPropName in m ? m[topLeftCornerPropName] : m[localTopLeftCornerPropName]).split(' ').map(v => Number(v))) : null,
                                        // }

                                        let wmtsConf = {
                                            layer: node.layers,
                                            requestEncoding: node.requestEncoding || 'KVP',
                                            srs: mapProjectionCode,
                                            matrixSet: matrixId,
                                            matrixIds: matrixIds,
                                            resolutions: resolutions,
                                            origins: origins,
                                            sizes: sizes,
                                            tileSizes: tileSizes,
                                            attributions: '',
                                        }
                                        wmtsConf = {...conf, ...wmtsConf};
                                        layer = _map.createWMTSLayer(wmtsConf);
                                    }
                                }else{
                                    this.showError('The map coordinate system is not supported by this service');
                                }
                                break;
                            default:
                                // code block
                        }
                        if(layer){
                            _map.setLayer(getTocLayerId(node), layer);
                            _map.addlayerToMap({layer: layer}, true);
                        }
                    }
                }
                if(layer){
                    // layer.setProperties({'featureInfo': node.get_feature_info, 'layerName': node.layers});
                    layer.setVisible(baseNode.state.checked);
                    layer.setOpacity(baseNode.state.opacity);
                    baseNode.state.loaded = true;
                }
                return layer;
            }
            return null;
        },
        getOLLayer(node, refId=null){
            node = this.layerNode(node);
            let layerId = getTocLayerId(node, refId);
            let layer = this.map.getLayer(layerId);
            return layer;
        },
        // getLegendUrlLayer(node){
        //     if(node.legend_automatic){
        //         let map = this.map;
        //         let layer = this.getOLLayer(node);
        //         if(!layer){
        //             layer = this.setLayerOnMap(node);
        //         }
        //         if(layer){
        //             let owsSource = layer.getSource()
        //             let resolution = map.getOLMap().getView().getResolution();
        //             return typeof owsSource.getLegendUrl === 'function' ? owsSource.getLegendUrl(resolution) : null;
        //         }
        //     }else if(node.legend_layer){
        //         let legend = node.legend_layer;
        //         if(!isArray(legend)){
        //             legend = [{'url': legend}];
        //         }
        //         if(legend.length){
        //             legend = legend[0];
        //             return legend.filename ? this.getFormatUrlAPI(legend.filename) : legend.url;
        //         }
        //     }
        //     return null;
        // },
        removeLayerFromMap(node){
            if(this.isNodeLayer(node)){
                let _map = this.map;
                let layer = this.getOLLayer(node);
                if(layer){
                    if(_map.removeLayer(layer)){
                        _map.setLayer(getTocLayerId(node), null);
                    }
                }
            }
        },
        calcZIndexLayer(node){
            let _map = this.map;
            let layers = _map.getLayers().getArray();
            let nodeIndex = 0;
            if(node.refZindex){
                let refZIndex = node.refZindex;
                let toUpdate = layers.filter(x => x.getZIndex() > refZIndex);
                nodeIndex = refZIndex + 1;
                toUpdate.sort((a, b) => (b.getZIndex() < a.getZIndex()) ? 1 : -1);
                toUpdate.map((x, idx) => {
                    x.setZIndex(nodeIndex + idx + 1);
                });
            }else{
                let maxZIndex = Math.max.apply(Math, layers.map(function(o) { return o.getZIndex(); }))
                nodeIndex = maxZIndex + 1;
            }
            return nodeIndex;
        },
        getEPSGCode(code) {
            if (code.indexOf(':') !== -1) {
                return 'EPSG:' + code.substring(code.lastIndexOf(':') + 1);
            }
            return code;
        },

    },
    watch: {

    },
};